import Immutable from 'immutable';
import {
  CLEAR_MANUAL_SENDER_REMISSION_GUIDE,
  CLEAR_MANUAL_SENDER_REMISSION_GUIDES,
  FLAG_GETTING_MANUAL_SENDER_REMISSION_GUIDE,
  FLAG_MANUAL_SENDER_REMISSION_GUIDE_ACTIVITY,
  GET_MANUAL_SENDER_REMISSION_GUIDE,
  GET_MANUAL_SENDER_REMISSION_GUIDES,
} from '../../../actions/types/cargo/ManualSenderRemissionGuide';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    price: Immutable.Set(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MANUAL_SENDER_REMISSION_GUIDE:
      return state.setIn(['all', 'loading'], payload);
    case GET_MANUAL_SENDER_REMISSION_GUIDES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MANUAL_SENDER_REMISSION_GUIDES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_MANUAL_SENDER_REMISSION_GUIDE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_MANUAL_SENDER_REMISSION_GUIDE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MANUAL_SENDER_REMISSION_GUIDE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
